import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import Register from "./pages/Register";
import Sports from "./pages/Sports";
import Casino from "./pages/Casino";
import LiveCasino from "./pages/LiveCasino";
import CrashGames from "./pages/CrashGames";
import Dashboard from "./pages/Dashboard";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Rules from "./pages/Rules";
import Licenses from "./pages/Licenses";
import Game from "./pages/Game";
import Layout from "./components/Layout";
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import ProfilePage from './pages/ProfilePage';
import { DepositPage } from './pages/DepositPage';
import { WithdrawalPage } from './pages/WithdrawalPage';
import { GameLobby } from './pages/GameLobby';
import { GamePage } from './pages/GamePage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import MySlotGame from "./pages/MySlotGame";
import { useAuth } from "./context/AuthContext";
// import SecureDataTester from "./components/SecureDataTester";
const queryClient = new QueryClient();

//
/*const Private = ({Item}) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated > 0 ? <Item /> : <Auth />;
};*/

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AuthProvider>
        <BrowserRouter basename="/">
        {/*<SecureDataTester />*/}
          <Routes>
            {/* Rotas Públicas */}
            <Route element={<Layout />}>

                <Route path="/" element={<Index />} />
                <Route path="/sports" element={<Sports />} />
                <Route path="/casino" element={<Casino />} />
                <Route path="/live-casino" element={<LiveCasino />} />
                <Route path="/crash-games" element={<CrashGames />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/licenses" element={<Licenses />} />
                <Route path="/game/:id" element={<Game />} />
                <Route path="/my-game" element={<MySlotGame />} />
            </Route>

            {/* Rotas de Autenticação */}
            <Route path="/login" element={<Auth />} />
            <Route path="/register" element={<Register />} />
            <Route path="/resset-senha" element={<ResetPasswordPage />} />

            {/* Rotas Protegidas */}
            <Route element={<Layout />}>
                <Route element={<ProtectedRoute />}>
                    {/*<Route exact path="/home" element={<Private Item={Home} />} />*/}
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/deposito" element={<DepositPage />} />
                    <Route path="/saque" element={<WithdrawalPage />} />
                    <Route path="/games" element={<GameLobby />} />
                    <Route path="/game/:gameId" element={<GamePage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                </Route>
            </Route>

            {/* Rota 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;